(function () {
  function initReveal(root) {
    var items = root.querySelectorAll('[data-about-reveal]');
    if (!items.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    items.forEach(function (el) { el.classList.add('reveal-ready'); });
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });
    items.forEach(function (el) { obs.observe(el); });
  }

  function initStats(root) {
    var stats = root.querySelectorAll('.stat-num[data-count]');
    if (!stats.length) return;
    var animate = function (el) {
      var target = parseInt(el.getAttribute('data-count'), 10) || 0;
      var suffix = el.getAttribute('data-suffix') || '';
      var dur = 1400;
      var start = performance.now();
      function tick(now) {
        var p = Math.min((now - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(eased * target).toLocaleString() + suffix;
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      stats.forEach(function (el) {
        el.textContent = (el.getAttribute('data-count') || '0') + (el.getAttribute('data-suffix') || '');
      });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          animate(e.target);
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.4 });
    stats.forEach(function (el) { obs.observe(el); });
  }

  function boot(root) {
    if (!root || root.getAttribute('data-about-ready')) return;
    root.setAttribute('data-about-ready', '1');
    initReveal(root);
    initStats(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-oxiram-about]').forEach(boot);
  });
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector('[data-oxiram-about]');
    if (root) boot(root);
  });
})();
